import { BetaPill } from '../beta-pill';
import type { SidecardHeaderWithBetaProps } from './types';

export const SidecardHeaderWithBeta: React.FC<SidecardHeaderWithBetaProps> = ({
  title,
}) => {
  return (
    <div className="sidecard-header-container">
      {title} <BetaPill className="sidecard-header-container__beta" />
    </div>
  );
};
